import React from 'react'
import update from 'immutability-helper';
import moment from 'moment'

import { tenantBilling } from '../../core/controllers/TenantBilling';
import { modal } from '../../core/utilities/modal';
import NavLink from '../Routes/NavLink';
import {TenantPayOption} from '../Billing/TenantPayOptions';

export default class TenantPayNow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            other: 0,
            formatOther: 0,
            transactionId: this.props.invoices ? this.props.invoices.tenant_payment_history_id : 0,
            usingCC: this.props.paysWithCard,
            showCardBankSelect: this.props.linked && this.props.paysWithCard,
            isInternationalCard: this.props.isInternationalCard
        }

        // Our fee of 1% is internal, no need to set this here.
        this.processingFee = 0.0;
        this.calculatedProcessingFee = 0.0;
        this.now = moment().format('MMMM Do YYYY');
        this.shouldUpdate = true;
        this.displayAutoPay = this.props.displayAutoPay ? this.props.displayAutoPay : false;
    }

    componentDidMount() {
        var self = this;
        jQuery("#auto-pay").bootstrapToggle(this.props.autoPay);
        // TODO figure out why onChange reactjs event does not trigger
        jQuery("#auto-pay").change(function(e){
            if(!self.shouldUpdate) {
                return;
            }
            const value = jQuery(e.target).prop('checked');
            const id = jQuery(e.target).attr('notification-type-id');
            tenantBilling.updateAutoPayOption(value, function() {
                self.props.reloadParent();
                modal.showInfo("Autopay has been turned " + (value ? 'on!' : 'off!'), "success", "top", "center");
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
        this.shouldUpdate = false;
        var onOff         = 'off';
        if (nextProps.autoPay == 'ON') {
            onOff         = 'on';
        }
        jQuery("#auto-pay").bootstrapToggle(onOff);
        this.shouldUpdate       = true;
        nextState.transactionId = nextProps.invoices ? nextProps.invoices.tenant_payment_history_id : 0;
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        var money = parseFloat(value);
        if(isNaN(money) || money === 0) {
            money = 0;
        } else {
            money = money / 100;
            money.toLocaleString("en-US", {style:"currency", currency:"USD"});
        }

        return money;
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    handleAmountChange(e) {
        var money = this.formatAmount(e.target.value);

        this.setState({
            other: e.target.value,
            formatOther: money
        });
    }

    getProcessingFee(charge) {
        var processingFee = charge * this.processingFee;
        processingFee = processingFee / 100;
        processingFee = processingFee.toFixed(4);
        return processingFee;
    }

    getTotalCharge(charge) {
        charge = parseFloat(charge);
        const processingFee = parseFloat(this.getProcessingFee(charge));
        this.calculatedProcessingFee = processingFee;
        var total = charge + processingFee;
        return total;
    }

    payFull() {
        var self = this;
        const charge = this.formatAmount(this.getTotalCharge(this.props.invoices.payment_details.charge));
        var creditCardFee = this.state.usingCC ? (1.03) : (1)
        const isInternational = this.state.isInternationalCard;
        var totalChargePlusFee = parseFloat(charge * creditCardFee).toFixed(2);
        if (creditCardFee > 1) {
            if (isInternational) {
                creditCardFee = 1.05;
                totalChargePlusFee = parseFloat((charge * creditCardFee) + 0.30).toFixed(2);
            } else {
                totalChargePlusFee = parseFloat((charge * creditCardFee) + 0.30).toFixed(2);
            }
        }

        if(totalChargePlusFee === undefined || totalChargePlusFee == 0) {
            modal.showInfo("There is no amount to be charged.", "danger", "top", "center");
            return;
        }

        if (this.state.usingCC && (totalChargePlusFee === undefined || totalChargePlusFee < 10)) {
            modal.showInfo("Minimum payment of $10 required for credit card transactions", "danger", "top", "center");
            return;
        }

        var ccMessage = '';
        if (creditCardFee > 1) {
            if (isInternational) {
                ccMessage = '</br></br>You are paying with an international card and a 5% + $0.30 fee is reflected in the charge above.';
            } else {
                ccMessage = '</br></br>You are paying with a card and a 3% + $0.30 fee is reflected in the charge above.';
            }
        }

        modal.showSuccessModalWithOK("Pay Now","Pay <b>$" + totalChargePlusFee + "</b> on " + this.now + ". " + ccMessage, "Pay!");
        jQuery(".move-on").on('click',function() {
            tenantBilling.pay(
                totalChargePlusFee,
                self.state.transactionId,
                self.state.usingCC,
                function(response) {
                if (typeof self.props.updatePaymentMade == 'function') {
                    self.props.updatePaymentMade();
                }
                modal.showInfo("Payment was successfully scheduled!", "success", "top", "center");
                self.props.reloadParent();
            });
        });
    }

    adminFees(data) {
        var total = parseFloat(data.late_rent);
        if(data.processing_fee > 0) {
            total += parseFloat(data.processing_fee);
        }

        return this.formatAmount(total);
    }

    handlePayMethodCahange = (e) => {
        var usingCC = false;
        if (e.target.value == "true") {
            usingCC = true;
        }
        this.setState({
            usingCC: usingCC
        });
    }

    render(){
        const contractInformation = this.props.contractInformation;
        const invoices = this.props.invoices;
        const billingSetup = this.props.billingSetup ? true : false;
        const autoPay = this.props.autoPay == 'ON' ? true : false;
        const displayAutoPay = this.displayAutoPay;
        const isInternational = this.state.isInternationalCard;
        const count = this.props.count
        var creditCardFee = this.state.usingCC ? (1.03) : (1)
        const totalCharge = invoices ? this.formatAmount(invoices.payment_details.charge) : null;
        var totalChargePlusFee = (totalCharge || totalCharge === 0) ? parseFloat(totalCharge * creditCardFee).toFixed(2) : null;
        if (creditCardFee > 1) {
            if (isInternational) {
                creditCardFee = 1.05;
                totalChargePlusFee = parseFloat((totalCharge * creditCardFee) + 0.30).toFixed(2);
            } else {
                totalChargePlusFee = parseFloat((totalCharge * creditCardFee) + 0.30).toFixed(2);
            }
        }
        const autoPayToggle = <input
            type="checkbox"
            class="toggle-switch"
            id="auto-pay"
            defaultChecked={autoPay}
            data-toggle="toggle"
        />
        const usingCC = this.state.usingCC
        return (
            <div class="card ps-full-width">
                <div class="header">
                    <h4 class="title">Latest Payment Due</h4>
                    <p class="category">You have a total of {count} outstanding payment{count > 1 && "s"}.</p>
                </div>
                <div class="content">
                    <div className="tenant-pay-now">
                        { contractInformation === null ? (
                            <div>
                                <p>
                                    No active leases.
                                </p>
                                <label for="effective_date">
                                    Autopay
                                </label>
                                <br/>
                                <input type="checkbox" class="toggle-switch" id="auto-pay" defaultChecked={autoPay} data-toggle="toggle" />
                            </div>
                        ) : (
                            invoices == null ? (
                                <p>You are all caught up with your payments.</p>
                            ) : (
                                <div>
                                    <div class="breakdown-grid">
                                        <label className="rent-payment-total-label">
                                            Total Due
                                        </label>
                                        <p className="rent-payment-total-p">
                                            {"$" + totalChargePlusFee}
                                        </p>
                                        <label className="breakdown-label">
                                            Rent
                                        </label>
                                        <p className="breakdown-p">
                                            {"$" + this.formatAmount(invoices.payment_details.rent)}
                                        </p>
                                        <label className="breakdown-label">
                                            Admin/Service Fees
                                        </label>
                                        <p className="breakdown-p">
                                            {"$" + this.adminFees(invoices.payment_details)}
                                        </p>
                                        {this.state.usingCC && (
                                            this.state.isInternationalCard ? (
                                            <label className="breakdown-label">
                                                International Credit Card Fee (5% + $0.30)
                                            </label>
                                            ) : (
                                            <label className="breakdown-label">
                                                Credit Card Fee (3% + $0.30)
                                            </label>
                                            )
                                        )}
                                        {this.state.usingCC && (
                                            this.state.isInternationalCard ? (
                                            <p className="breakdown-p">
                                                {"$" + parseFloat((totalCharge * 0.05) + 0.30).toFixed(2)}
                                            </p>
                                            ) : (
                                            <p className="breakdown-p">
                                                {"$" + parseFloat((totalCharge * 0.03) + 0.30).toFixed(2)}
                                            </p>
                                            )
                                        )}
                                    </div>
                                    {this.state.showCardBankSelect && (
                                    <div className="paynow payment-row">
                                        <label>Payment method</label>
                                        <select class="form-control" value={usingCC} onChange={this.handlePayMethodCahange}>
                                            <option value={"true"}>Credit Card</option>
                                            <option value={"false"}>Bank Account</option>
                                        </select>
                                    </div>
                                    )}
                                    <div class="payment-row">
                                        <b>Payment Due {moment(invoices.payment_due_date).format('MMMM Do YYYY')} {this.props.autoPay == 'ON' && (<span>- this amount will be automatically withdrawn if a bank account is connected.</span>)}</b>
                                    </div>
                                    <div className="payment-row">
                                        <p className="rent-autopay-label">
                                            Autopay
                                        </p>
                                        { autoPayToggle }
                                    </div>
                                    <div className="paynow payment-row">
                                        {(billingSetup === false && !this.props.paysWithCard) ? (
                                            <NavLink to={"/account/billing"}>
                                                <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill pull-right" autoComplete="off">
                                                    Pay Now
                                                </button>
                                            </NavLink>
                                        ) : (
                                            <button 
                                                type="button" 
                                                id="save-tenant" 
                                                onClick={this.payFull.bind(this)} 
                                                data-loading-text="Loading..." 
                                                class="btn btn-secondary btn-info btn-fill pull-right" 
                                                autoComplete="off"
                                                disabled={totalCharge === 0}
                                            >
                                                Pay Now
                                            </button>
                                        )}
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>
        );
    }
};
/* <div class="col-md-12 breakdown">
    <div class="form-group">
        <label>Water</label>
        <p>{"$" + this.formatAmount(invoices.payment_details.water)}</p>
    </div>
</div>
<div class="col-md-12 breakdown">
    <div class="form-group">
        <label>Disposal</label>
        <p>{"$" + this.formatAmount(invoices.payment_details.disposal)}</p>
    </div>
</div>
<div class="col-md-12 breakdown">
    <div class="form-group">
        <label>Sewage</label>
        <p>{"$" + this.formatAmount(invoices.payment_details.sewage)}</p>
    </div>
</div> */


// WEBPACK FOOTER //
// app/components/Billing/TenantPayNow.jsx